<template>
  <div class="login-wrapper">
    <profile-select
      v-if="isVisibleProfileSelect"
      :close-fn="closeOnSuccess"
    ></profile-select>
  </div>
</template>

<script>
  import { get } from 'lodash'
  import utils from '@/common/util/utils'
  import ProfileSelect from '@/views/lnb/ProfileSelect'
  import { URL_PROTOCOL_DOMAIN, URL_COOKIE_DOMAIN } from '@/common/constant'
  import { parseUrl, stringify } from 'query-string'
  export default {
    name: 'TloginCallback',
    components: {
      ProfileSelect,
    },
    data() {
      return {
        token: '',
        isVisibleProfileSelect: false,
        signupResultCode: '302',
      }
    },
    created() {
      this.setCallbackData()
    },
    methods: {
      login(token, promotionCode) {
        utils.login
          .loginProc(
            {
              userType: 'tid',
              userId: token,
              userPassword: '',
              saveId: '',
              autoLogin: '',
            },
            (error) => {
              if (
                error.response.status === 551 &&
                get(error, 'response.data.resultoptional', '') !== '' &&
                error.response.data.resultcode === this.signupResultCode
              ) {
                const { url, query } = parseUrl(
                  error.response.data.resultoptional,
                )
                if (promotionCode !== '') query.promotioncode = promotionCode
                window.location.href = `${url}?${stringify(query)}`
              }
            },
          )
          .then(({ data }) => {
            if (data.needselectprofile === 'y') {
              // 프로필 선택 화면이 필요하면
              this.isVisibleProfileSelect = true
            } else {
              this.closeOnSuccess()
            }
          })
      },
      closeOnSuccess() {
        const referer = utils.cookies.getItem('referer-url')
        if (referer) {
          utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
          location.replace(referer)
        } else {
          location.href = URL_PROTOCOL_DOMAIN
        }
      },
      setCallbackData() {
        this.token = get(this.$route, ['query', 'token'], '')
        const promotionCode = get(this.$route, 'query.promotioncode', '')
        if (this.token) {
          const fromPartnersPageKey =
            utils.cookies.getItem('need-pp-token') || null
          if (fromPartnersPageKey === null) {
            this.login(this.token, promotionCode)
          } else {
            utils.cookies.removeItem('need-pp-token')
            location.replace(
              'https://pp.wavve.com/?type=tid&id_token=' + this.token,
            )
          }
        }
      },
    },
  }
</script>
